import { LinkSelector, getLink } from "./linkgenius-link-selector";
import { linkgenius_icon } from "./linkgenius-icon";
import { __, sprintf } from "@wordpress/i18n"
import { TextControl, Spinner, ToolbarGroup, ToolbarButton, SelectControl  } from "@wordpress/components"
import { useState, RawHTML, useEffect, Fragment } from "@wordpress/element";
const { registerBlockType } = wp.blocks;
import { BlockControls, InnerBlocks } from "@wordpress/block-editor";
import LinkGeniusTaxonomySelector from "./linkgenius-taxonomy-selector";
import { useSelect } from "@wordpress/data";
import { addFilter } from "@wordpress/hooks";
import { LinkGeniusTooltip } from "./linkgenius-tooltip";
const ALLOWED_PLACEHOLDERS = linkgenius_editor_data['allowed_placeholders'];

registerBlockType('linkgenius/linkblock', {
	title: 'LinkGenius Link',
	category: 'linkgenius',
	icon: linkgenius_icon,
	attributes: {
		text: {
			type: "string",
		},
		linkgenius_id: {
			type: "string",
		}
	},
	description: 'Display an LinkGenius Link ',
	keywords: ['LinkGenius', 'affiliate', 'link'],
	edit: (props) => {
		if(props === undefined)
			return;
		const {attributes, setAttributes } = props;
		const [link, setLink] = useState(null);
		const [isPreviewMode, setPreviewMode] = useState(attributes.linkgenius_id !== undefined);
		const [loading, setLoading] = useState(attributes.linkgenius_id !== undefined);
		
		let unselected = "";
		if(isPreviewMode) {
			if(loading) {
				unselected = (<div className="linkgenius-link-preview"><Spinner></Spinner></div>)
			}
			else {
				if(link === null) {
					unselected = (<div className="linkgenius-link-preview">{__("No LinkGenius Link Selected", 'linkgenius')}</div>)
				}
				else {
					unselected = (<div className="linkgenius-link-preview"><a href={link.url}>{attributes.text}</a></div>)
				}
			}
		}
		return (
			<div>
				<BlockControls>
					<ToolbarGroup label={ __( 'LinkGenius Link Settings' ) }>
						<ToolbarButton
							label={ isPreviewMode ? __( 'Edit LinkGenius Link', 'linkgenius' ) : __( 'Preview LinkGenius Link', 'linkgenius' ) }
							icon={isPreviewMode ? "edit" : "visibility"}
							onClick={() => setPreviewMode(!isPreviewMode) }
						/>
					</ToolbarGroup>
				</BlockControls>
				<div className={!isPreviewMode ? "linkgenius-link-wrapper" : "linkgenius-link-wrapper-hidden"}>
					<h2>{__("LinkGenius Link", 'linkgenius')}</h2>
					{__('Text', 'linkgenius')}: <TextControl 
						value={attributes.text}
						onChange={(newtext) => setAttributes({ text: newtext })}
					/>
					{__('Link', 'linkgenius')}:
					<LinkSelector 
						link_id={attributes.linkgenius_id}
						onChange={(id, link) => {
							setAttributes({linkgenius_id: id+""});
							setLink(link);
						}}
						onLinkLoaded={link => {
							setLink(link)
							setLoading(false)
						}}
					/>
				</div>
				{unselected}
			</div>	
		);
	},
	save: ({attributes}) => {
        const shortcodeString = '[linkgenius-link id="'+(attributes.linkgenius_id??'')+'"]'+attributes.text+'[/linkgenius-link]'
		return <wp.element.RawHTML>{shortcodeString}</wp.element.RawHTML>
	}
});

registerBlockType('linkgenius/categoryblock', {
	title: 'LinkGenius Category List',
	category: 'linkgenius',
	icon: linkgenius_icon,
	attributes: {
		item_slug: {
			type: "string",
		},
		template: {
			type: "string",
			default: `<ul>
	{links}
		<li>{link}</li>
	{/links}
</ul>`
		},
		template_type: {
			type: "string",
			default: "blocks"
		},
		sort: {
			type: "string",
			default: "order"
		}
	},
	description: 'Display all links of an LinkGenius Link Category ',
	keywords: ['LinkGenius', 'affiliate', 'link', 'category'],
	edit: (props) => {
		return <LinkGeniusTaxonomySelector {...props} taxonomy="category" />
	},
	save: ({attributes}) => {
		const isBlock = attributes.template_type == 'blocks';
		const shortcodeString = '[linkgenius-list category="'+(attributes.item_slug ?? '')+'"'+(isBlock ? ' blocks=true' : '')+']\n';
		return (
			<Fragment>
				{shortcodeString}
					{isBlock ? <InnerBlocks.Content /> : attributes.template }
				{ '\n[/linkgenius-list]'  }
			</Fragment>
		);
	}
});

registerBlockType('linkgenius/tagblock', {
	title: 'LinkGenius Tag List',
	category: 'linkgenius',
	icon: linkgenius_icon,
	attributes: {
		item_slug: {
			type: "string",
		},
		template: {
			type: "string",
			default: `<ul>
	{links}
		<li>{link}</li>
	{/links}
</ul>`
		},
		template_type: {
			type: "string",
			default: "blocks"
		},
		sort: {
			type: "string",
			default: "order"
		}
	},
	description: 'Display all links of an LinkGenius Tag ',
	keywords: ['LinkGenius', 'affiliate', 'link', 'tag'],
	edit: (props) => {
		return (
			<div>
				<LinkGeniusTaxonomySelector {...props} taxonomy="tag" />
			</div>
		)
	}
	,
	save: ({attributes}) => {
		const isBlock = attributes.template_type == 'blocks';
		const shortcodeString = '[linkgenius-list category="'+(attributes.item_slug ?? '')+'"'+(isBlock ? ' blocks=true' : '')+']\n';
		return (
			<Fragment>
				{shortcodeString}
					{isBlock ? <InnerBlocks.Content /> : attributes.template }
				{ '\n[/linkgenius-list]'  }
			</Fragment>
		);
	}
});

registerBlockType('linkgenius/linkloop', {
    title: 'LinkGenius Link Loop',
    category: 'linkgenius',
    ancestor: ['linkgenius/tagblock', 'linkgenius/categoryblock'],
	attributes: {},
	supports: {
		layout: {
			allowSizingOnChildren: true,
			allowEditing: false,
		}
	},
    icon: linkgenius_icon,
    edit: (props) => {
		const { setAttributes} = props;
		const {allowedBlocks, layoutAttributes} = useSelect((select) => {
			var allowedBlocks = [];
			var layoutAttributes = [];
            const parent = select('core/block-editor').getBlockParents(props.clientId);
            if(parent.length > 0) {
				layoutAttributes = select('core/block-editor').getBlockAttributes(parent.at(-1)).layout;
                allowedBlocks = select('core/block-editor').getAllowedBlocks(parent.at(-1));
				allowedBlocks = allowedBlocks.filter(block => block !== 'linkgenius/linkloop').map(block => block.name);
            }
			allowedBlocks.push('linkgenius/linkdata');
			return { allowedBlocks, layoutAttributes };
        }, [props.clientId]);
		useEffect(() => setAttributes({ layout: layoutAttributes }), [layoutAttributes]);
        return (
            <div>
				<h3 className="linkgenius-loop-title">{__('LinkGenius Link Loop', 'linkgenius')}
					<LinkGeniusTooltip text={sprintf(__('The blocks within the LinkGenius Link Loop are repeated for each link. You can use the following placeholders to ouput data: %s ', 'linkgenius')
						, ALLOWED_PLACEHOLDERS.map(a => "{{lg_"+a.value+"}}").join(", "))} />
				</h3>
                <InnerBlocks allowedBlocks={allowedBlocks} />
            </div>
        );
    },
    save: () => {
        return (<linkgenius-links><InnerBlocks.Content /></linkgenius-links>);
    }
});

registerBlockType('linkgenius/linkdata', {
    title: 'LinkGenius Link Data',
    category: 'linkgenius',
    ancestor: ['linkgenius/linkloop'],
    icon: linkgenius_icon,
    attributes: {
        field: {
            type: 'string',
			default: 'link'
        },
    },
    edit: (props) => {
        const { attributes: { field }, setAttributes } = props;
        return (
			<div>
				<SelectControl
					label="Field"
					value={field}
					options={ALLOWED_PLACEHOLDERS}
					onChange={(value) => setAttributes({ field: value })}
				/>
			</div>
        );
    },
    save: (props) => {
        const { attributes: { field } } = props;
        return <span>{`{{lg_${field}}}`}</span>; // Placeholder for dynamic data
    }
});

function extendLinkgeniusAllowedBlocks(settings, name) {
	if(name.startsWith('linkgenius/') || settings.allowedBlocks === undefined) {
		return settings;
	}
	var newAllowedBlocks = [ // allow linkdata everywhere (if within a linkloop block, see above)
		...settings.allowedBlocks || [],
		'linkgenius/linkdata',
	];
	// allow linkloop in some additional blocks
	const additionalBlocks = [
		'core/list', 'core/buttons', 'core/columns', 'core/navigation'
	];
	if(additionalBlocks.includes(name)) {
        newAllowedBlocks.push('linkgenius/linkloop');
    }
	
	settings.allowedBlocks = newAllowedBlocks;
    return settings;
}
addFilter(
    'blocks.registerBlockType',
    'linkgenius/extend-linkgenius-allowed-blocks',
    extendLinkgeniusAllowedBlocks
);